import { Icon } from '@material-ui/core';
import React from 'react';
import '../../assets/css/material.css';
/**
 * Material Icon component
 */
export const MaterialIcon = props => {
  const {
    color,
    fontSize,
    classes,
    iconName,
    style,
    onClick,
    className
  } = props;
  return /*#__PURE__*/React.createElement(Icon, {
    color: color || 'primary',
    fontSize: fontSize || 'default',
    classes: classes,
    style: style,
    onClick: onClick,
    className: className
  }, iconName, props.children);
};
//# sourceMappingURL=Icon.js.map